import React, { useEffect, useState } from 'react';

import GetAppIcon from '@material-ui/icons/GetApp';
import SendIcon from '@material-ui/icons/Send';

import { Button, Grid, makeStyles } from '@material-ui/core';

import DialogComponent from 'app/components/DialogComponent';
import SaveBox from '../../components/SaveBox';
import Loading from 'app/layouts/Loading';
import { downloadFile } from 'app/utils/forms/files';
import { errorHandler } from 'app/utils/errorHandler';
import lineEndpoint from 'app/api/services/lineEndpoint';
import { Alert } from '@material-ui/lab';
import notification from '../../../../config/notification';
import InfoLineCompany from '../../components/InfoLineCompany';
import { useDispatch, useSelector } from 'react-redux';
import { DOCUMENT_TYPES } from '../../../../utils/constants';

function ApostilleModal(props) {
  const classes = useStyles();
  const { open, onClose, data, onUpdate } = props;

  const [loading, setLoading] = useState(false);
  const [idFile, setIdFile] = useState('');
  const [idFilePublishText, setIdFilePublishText] = useState('');
  const [processId, setProcessId] = useState(null);
  const [requestId, setRequestId] = useState(null);
  const [requestNumber, setRequestNumber] = useState(null);
  const [processNumber, setProcessNumber] = useState(null);

  const selectedLineStore = useSelector(state => state.line.selected);

  const dispatch = useDispatch();

  useEffect(() => {
    (() => {
      if (data.apostille) {
        setIdFile(data.apostille.idFile);
        setProcessId(data.apostille.cdProcesso);
        setProcessNumber(data.apostille.nuProcesso);
        setRequestId(data.apostille.cdSolicitacao);
        setRequestNumber(data.apostille.nuSolicitacaoFmt);
        setIdFilePublishText(data.apostille.idFileTextoDiarioOficial);
      }
    })();
  }, [data]);

  const handleCancel = () => {
    onClose();
  };

  const handleGenerate = async () => {
    setLoading(true);
    try {
      if (data?.apostille?.cdLinhaApostila) {
        const response = await lineEndpoint.generateApostilleFile(
          data.apostille.cdLinhaApostila,
        );
        if (response && response.status === 200) {
          notification('Apostila e Texto para publicação no D.O. gerados com sucesso', {
            toastId: 'VALIDATION',
            type: 'success',
          });
          const certificates = response.data;
          const apostille = certificates.find(apo => apo.cdTipoDocumento === DOCUMENT_TYPES.APOSTILA);
          const publishText = certificates.find(apo => apo.cdTipoDocumento === DOCUMENT_TYPES.TEXTO_PUBLICACAO_DIARIO_OFICIAL);

          const apostilleData = {
            ...data.apostille,
            ...response.data,
            idFile: apostille.idFileCrc,
          };

          onUpdate(apostilleData);
          setIdFile(apostille.idFileCrc);
          setIdFilePublishText(publishText.idFileCrc);

          const hasActiveContract = await lineEndpoint.getActiveContractByLine(selectedLineStore.cdLinha);
          if (hasActiveContract && !hasActiveContract.data) {
            notification('O contrato de concessão/permissão para a linha não é válido ou está vencido, favor verificar', {
              toastId: 'ACTIVE_CONTRACT',
              type: 'warning',
            });
          }
        }
      } else {
        notification('Apostila não identificada', { toastId: 'VALIDATION', type: 'error' });
      }
    } catch (error) {
      errorHandler(error.response?.status, error.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const sendDocument = async () => {
    if (!data.apostille) {
      notification('Erro ao identificar apostila', { toastId: 'VALIDATION', type: 'error' });
      return;
    }
    setLoading(true);
    let response = null;
    let requestProcessNumber = requestNumber;
    let requestProcessLabel = 'na solicitação';
    if (requestId && requestId !== '') {
      response = await lineEndpoint.sendApostilleToRequest(data.apostille);
    } else if (processId && processId !== '') {
      requestProcessNumber = processNumber;
      requestProcessLabel = 'no processo';
      response = await lineEndpoint.sendApostilleToProcess(data.apostille);
    }
    if (!response || response.status !== 200) {
      notification('Erro ao encaminhar documento', { toastId: 'VALIDATION', type: 'error' });
      setLoading(false);
      return;
    }
    notification(`Apostila e Texto para publicação no D.O. incluídos ${requestProcessLabel} ${requestProcessNumber} com sucesso.`, { type: 'success' });
    setLoading(false);
    onClose();
  };

  return (
    <DialogComponent
      title={'Emissão de Apostila e texto de publicação'}
      subtitle={''}
      open={open}
      onClose={onClose}
    >
      <>
        {loading && <Loading />}
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Alert severity='info'>
              Antes de emitir o documento, certifique-se de que todas as informações da apostila foram salvas!
            </Alert>
          </Grid>

          <InfoLineCompany selectedLine={selectedLineStore} fullWidth={true} />

          {idFile && idFile !== '' && (
            <>
              <Grid item xs={4}>
                <Button
                  color='secondary'
                  className={classes.button}
                  startIcon={<GetAppIcon />}
                  onClick={async () => await downloadFile({ idFile, dispatch })}
                >
                  Exibir Apostila
                </Button>
              </Grid>
              <Grid item xs={4}>
                {(processId || requestId) && (
                  <Button
                    color='primary'
                    className={classes.button}
                    startIcon={<SendIcon />}
                    onClick={() => sendDocument()}
                  >
                    Encaminhar
                  </Button>
                )}
              </Grid>
            </>
          )}

          {idFilePublishText && idFilePublishText !== '' && (
            <Grid item xs={12}>
              <Button
                color='secondary'
                className={classes.button}
                startIcon={<GetAppIcon />}
                onClick={async () => await downloadFile({ idFile: idFilePublishText, dispatch })}
              >
                Exibir texto para publicação
              </Button>
            </Grid>
          )}

          <Grid item xs={12}>
            <SaveBox
              onCancel={handleCancel}
              onSave={handleGenerate}
              onSaveColor={'secondary'}
              middleButtonLabel={'Gerar'}
              onSaveStyles={{ color: '#fff' }}
              removeSpacing={true}
            />
          </Grid>
        </Grid>
      </>
    </DialogComponent>
  );
}

const useStyles = makeStyles(theme => ({
  button: {
    marginRight: '20px',
  },
}));

export default ApostilleModal;
